var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import S from 's-js';
import * as Surplus from "surplus";
import data from 'surplus-mixin-data';
import { Page } from "./Page";
import { TagList } from './TagList';
import { RequestErrors } from './RequestErrors';
export { EditorRoute };
const EditorRoute = (app, slug) => __awaiter(this, void 0, void 0, function* () {
    const article = !slug ? null : (yield app.client.article.get(slug)).article;
    const model = EditorModel(app, article, a => app.location.change(`#/article/${a.slug}`));
    return () => <EditorPage {...model}/>;
}), EditorModel = (app, article, onPublish) => {
    const title = S.value(article ? article.title : ""), description = S.value(article ? article.description : ""), body = S.value(article ? article.body : ""), tags = S.value(article ? article.tagList.join(" ") : ""), tagList = () => tags().match(/\S+/g) || [], request = S.data(null), publish = () => {
        const data = {
            title: title(),
            description: description(),
            body: body(),
            tagList: tagList()
        }, req = article
            ? app.client.article.put(Object.assign({}, article, data))
            : app.client.articles.post(data);
        request(req);
        req.then(s => onPublish(s.article));
        return false;
    };
    return { app, title, description, body, tags, tagList, request, publish };
}, EditorPage = (model) => (<Page app={model.app} title="Editor - Conduit" section={1 /* NewPost */}>
            <Editor {...model}/>
        </Page>), Editor = ({ title, description, body, tags, tagList, publish, request }) => (<div class="editor-page">
            <div class="container page">
                <div class="row">
                    <div class="col-md-10 offset-md-1 col-xs-12">
                        <RequestErrors request={request}/>
                        <form>
                            <fieldset>
                                <fieldset class="form-group">
                                    <input fn={data(title)} type="text" class="form-control form-control-lg" placeholder="Article Title"/>
                                </fieldset>
                                <fieldset class="form-group">
                                    <input fn={data(description)} type="text" class="form-control" placeholder="What's this article about?"/>
                                </fieldset>
                                <fieldset class="form-group">
                                    <textarea fn={data(body)} class="form-control" rows={8} placeholder="Write your article (in markdown)"/>
                                </fieldset>
                                <fieldset class="form-group">
                                    <input fn={data(tags)} type="text" class="form-control" placeholder="Enter tags"/>
                                    <TagList {...tagList()}/>
                                </fieldset>
                                <button class="btn btn-lg pull-xs-right btn-primary" type="button" onClick={publish}>
                                    Publish Article
                                </button>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>);
